var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDallaslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_3063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5144 0.00250244L29.8308 34.8217L0.205078 13.306H36.8152L7.19792 34.8217L18.5144 0.00250244Z",
    fill: "#0D254C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5144 3.21716L27.9377 32.2204L3.2666 14.2948H33.7622L9.09113 32.2204L18.5144 3.21716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5143 5.71576L26.4708 30.1992L5.63721 15.0708H31.3828L10.5578 30.1992L18.5143 5.71576Z",
    fill: "#0D254C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 24.4259L18.2075 25.1508L18.7959 24.9376L18.5059 24.4259H17.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 25.3725L18.1904 25.6113L19.1711 24.895L18.506 24.4259L17.2012 25.3725ZM12.1186 25.3981L13.3466 21.6203L12.69 21.1427L11.2402 25.6113L12.1186 25.3981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8582 24.8949L18.5063 24.4259L13.5942 20.8527L13.3469 21.6202L13.2275 21.9784L17.2015 25.3725L17.8582 24.8949Z",
    fill: "#0D254C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_3063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.6101,
    height: 34.8235,
    fill: "white",
    transform: "translate(0.205078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDallaslogo);
export default __webpack_public_path__ + "static/media/dallaslogo.1e11ffe75d7323a321dbfe7454218433.svg";
export { ForwardRef as ReactComponent };